module.exports = __webpack_public_path__ + "static/media/objective.deb74802.svg";